import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PosOperator } from '../../_models/fundraising/PosOperator';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';


@Injectable()
export class OperatorService {

  public apiUrl = getUrl();

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) { }

    public getAll(): Observable<PosOperator[]> {
        return this.http.get<PosOperator[]>(getUrl('fundraising/operator'), this.requestOptionsAuthenticated('portal'));
    }

    public getById(id: number): Observable<PosOperator> {
      return this.http.get<PosOperator>(getUrl(`fundraising/operator/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public create(data: PosOperator): Observable<PosOperator> {
      return this.http.post<PosOperator>(getUrl(`fundraising/operator/create`), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: PosOperator): Observable<PosOperator> {
      return this.http.post<PosOperator>(getUrl(`fundraising/operator/update`), data, this.requestOptionsAuthenticated('portal'));
    }

    public delete(id: number) {
      return this.http.get<any>(getUrl(`fundraising/operator/delete/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public reactivate(id: number) {
      return this.http.get<any>(getUrl(`fundraising/operator/reactivate/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public register(email: string, password: string) {
      const operatorData = { email, password };
      return this.http.post<any>(getUrl('fundraising/operator/register'), operatorData, this.requestOptionsAuthenticated('operatorOnboarding'));
    }

    public resendOnboardingUrl(operatorId: number): Observable<any> {
      return this.http.get<any>(getUrl('fundraising/operator/resend-invite/' + operatorId), this.requestOptionsAuthenticated('portal'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }

  }